import { PaceError } from '@evorait/pace-logging';

export class OfflinePluginDoubleCacheError extends PaceError {}
